// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","Wrap":"Footer_Wrap__2Rgo1","Stats":"Footer_Stats__z2FzT","Part":"Footer_Part__2via6","Copy":"Footer_Copy__12U4F"};